import { useTranslation } from '@sib/i18n';
import { SibAndSpendBrain } from '../icons';

export const Hero = () => {
  const { t } = useTranslation();

  return (
    <div className="flex max-w-[550px] flex-col md:gap-12 xl:gap-16">
      <SibAndSpendBrain aria-label="SIB SpendBrain logo" />
      <div className="flex flex-col">
        <h1 className="text-primary text-4xl leading-none font-bold tracking-[-1.35px] uppercase xl:text-6xl">
          {t('components.hero.title')}
        </h1>
        <p className="text-primary text-base leading-[24px]">
          {t('components.hero.description')}
        </p>
      </div>
    </div>
  );
};
